/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.standAnime)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.standAnime = exports.storyAnchor = exports.storySlider = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// storySlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var storySlider = function storySlider() {
	  $(".gallery-list").each(function (i) {
	    $(this).slick({
	      slidesToShow: 1,
	      slidesToScroll: 1,
	      arrows: true,
	      dots: true,
	      speed: 500,
	      cssEase: 'ease',
	      variableWidth: true,
	      appendArrows: '#slideNav_Wrap-' + i,
	      appendDots: '#slideNav_Dots-' + i,
	      responsive: [{
	        breakpoint: 768,
	        settings: {
	          slidesToShow: 1,
	          swipeToSlide: true,
	          swipe: true,
	          edgeFriction: 0.01
	        }
	      }]
	    });
	  });
	}; // ------------------------------------------------------------------------
	// storyAnchor
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.storySlider = storySlider;
	
	var storyAnchor = function storyAnchor() {
	  $(window).on('load', function () {
	    // 追従メニューの出現タイミング調整
	    var listHeight = $(".anm-Stories").outerHeight() - windowHeight / 2; // 開始位置から終了位置までの距離計算
	
	    var area01Height = $("#ep-10").outerHeight() + $("#ep-10").offset().top - $("#ep-01").offset().top;
	    var area02Height = $("#ep-20").outerHeight() + $("#ep-20").offset().top - $("#ep-11").offset().top;
	    var area03Height = $("#ep-30").outerHeight() + $("#ep-30").offset().top - $("#ep-21").offset().top;
	    var area04Height = $("#ep-39").outerHeight() + $("#ep-39").offset().top - $("#ep-31").offset().top;
	    var area05Height = $("#ep-48").outerHeight() + $("#ep-48").offset().top - $("#ep-41").offset().top;
	    var controller = new ScrollMagic.Controller();
	    new ScrollMagic.Scene({
	      triggerElement: "#ep-01",
	      duration: listHeight
	    }).setClassToggle(".anm-Stories_Anchor_Fixed", "visible").addTo(controller);
	    new ScrollMagic.Scene({
	      triggerElement: "#ep-01",
	      duration: area01Height
	    }).setClassToggle("#anchor-item-01", "current").addTo(controller);
	    new ScrollMagic.Scene({
	      triggerElement: "#ep-11",
	      duration: area02Height
	    }).setClassToggle("#anchor-item-02", "current").addTo(controller);
	    new ScrollMagic.Scene({
	      triggerElement: "#ep-21",
	      duration: area03Height
	    }).setClassToggle("#anchor-item-03", "current").addTo(controller);
	    new ScrollMagic.Scene({
	      triggerElement: "#ep-31",
	      duration: area04Height
	    }).setClassToggle("#anchor-item-04", "current").addTo(controller);
	    new ScrollMagic.Scene({
	      triggerElement: "#ep-41",
	      duration: area04Height
	    }).setClassToggle("#anchor-item-05", "current").addTo(controller);
	  });
	}; // ------------------------------------------------------------------------
	// standAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.storyAnchor = storyAnchor;
	
	var standAnime = function standAnime() {
	  $(window).on('scroll load', function () {
	    $('.stand-anm').each(function () {
	      var targetPos = $(this).offset().top;
	      var scrollPos = $(window).scrollTop();
	      var windowHeight = $(window).height();
	
	      if (scrollPos > targetPos - windowHeight + windowHeight / 2) {
	        $(this).addClass("animated");
	      }
	    });
	  });
	};
	
	exports.standAnime = standAnime;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// character/app.bundle.js